import PropTypes from 'prop-types';

import { getClassNames } from '../../../utils/util';

import { ReactComponent as EditIcon } from '../../../resources/icons/buzz-edit.svg';
import { ReactComponent as TrashIcon } from '../../../resources/icons/buzz-trash.svg';

import './poll.scss';

const Poll = ({ poll, editPoll, deletePoll, createReaction, deleteReaction, post }) => {
  if (!poll) return null;

  const totalVotes = poll.options.reduce((total, option) => total + option.votes, 0);

  const handleOptionClick = (option) => {
    if (!post) return;

    if (option.voted) {
      deleteReaction(option.value);
      return;
    }

    const { options } = poll;
    if (options.some((option) => option.voted)) {
      deleteReaction(options.find((option) => option.voted).value);
    }

    createReaction(option.value, option.voted);
  };

  const renderOptions = () => {
    return poll.options.map((option) => {
      let votePercentage = 0;

      if (option.votes > 0 && totalVotes > 0) {
        votePercentage = votePercentage = Math.round((option.votes / totalVotes) * 100);
      }

      return (
        <div className="poll__option-container" key={option.id}>
          <div
            className={getClassNames('poll__option', { post, dark: true })}
            style={{ clipPath: `inset(0 ${100 - votePercentage}% 0 0)` }}
            onClick={() => handleOptionClick(option)}
          >
            <div className="poll__option__left">
              {post && (
                <div className="poll__option-checkbox">
                  {option.voted && <div className="poll__option-checkbox__check" />}
                </div>
              )}
              <p className="poll__option-text poll__option-text--light">{option.value}</p>
            </div>
            {post && <p className="poll__option-text poll__option-text--light">{votePercentage}%</p>}
          </div>
          <div
            className={getClassNames('poll__option', { post, light: true })}
            style={{ clipPath: `inset(0 0 0 ${votePercentage}%)` }}
            onClick={() => handleOptionClick(option)}
          >
            <div className="poll__option__left">
              {post && (
                <div className="poll__option-checkbox">
                  {option.voted && <div className="poll__option-checkbox__check" />}
                </div>
              )}
              <p className="poll__option-text poll__option-text--dark">{option.value}</p>
            </div>
            {post && <p className="poll__option-text poll__option-text--dark">{votePercentage}%</p>}
          </div>
        </div>
      );
    });
  };

  return (
    <div className={getClassNames('poll', { post })}>
      <div className="poll__header">
        <p className="poll__question">{poll.question}</p>
        <div className="poll__icon-container">
          {editPoll && <EditIcon onClick={editPoll} />}
          {deletePoll && <TrashIcon onClick={deletePoll} />}
        </div>
      </div>
      <div className="poll__options">{renderOptions()}</div>
      {post && (
        <div className="poll__votes">
          <p>{totalVotes} votes</p>
        </div>
      )}
    </div>
  );
};

Poll.propTypes = {
  poll: PropTypes.shape({}),
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  createReaction: PropTypes.func,
  deleteReaction: PropTypes.func,
  post: PropTypes.bool,
};

Poll.defaultProps = {
  poll: undefined,
  onEditClick: undefined,
  onDeleteClick: undefined,
  createReaction: undefined,
  deleteReaction: undefined,
  post: false,
};

export default Poll;
